module.exports = __webpack_public_path__ + "img/family-anim.a310b099.svg";